import React, { Suspense } from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader'; 
import LoadingModal from 'components/presenters/modal/LoadingModal';
import styled from 'styled-components';

export default function TermsAndConditionsPage() {
    const TermsAndConditions = React.lazy(() => import('components/containers/mypage/TermsAndConditions'));
    return (
    	<PageLayout>
    	   <TitleHeader title={"이용 약관"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>
        
            <Suspense fallback={<LoadingModal zIndex={500}/>}>
                <TermsAndConditions />
            </Suspense>
        </PageLayout>
    )
}


const PageLayout = styled.div`
	padding-top : 72px;
`;
